<template>
  <div id="modal_voting">
    <div class="header_modal fs_big tal_c">
      {{ $t("msg.modalNetwork.title") }}
    </div>
    <p class="tal_c fat text_purple fs_big m13_t">
      {{ $t("msg.dear_blu_holder") }},
    </p>
    <div class="body_modal">
      <div>
        <br />
        <p
          class="tal_l text_grey fs_small"
          v-html="$t('msg.modalNetwork.text_one')"
        ></p>
        <br />
        <p class="tal_l fs_small text_purple fat">
          {{ $t("msg.modalNetwork.title_two") }}
        </p>
        <p
          class="tal_l text_grey fs_small"
          v-html="$t('msg.modalNetwork.text_two')"
        ></p>
        <ul style="list-style: disc; padding-left: 50px; margin-top: 20px; margin-bottom: 20px;" class="tal_l text_grey fs_small">
          <li v-html="$t('msg.modalBlueClub.text1')"></li>
          <li>
            {{ $t("msg.modalBlueClub.text2") }}
          </li>
          <li>
            {{ $t("msg.modalBlueClub.text3") }}
          </li>
          <li>
            {{ $t("msg.modalBlueClub.text4") }}
          </li>
          <li>
            {{ $t("msg.modalBlueClub.text5") }}
          </li>
        </ul>
        <p
          class="tal_l text_grey fs_small"
          v-html="$t('msg.modalNetwork.text_two_t')"
        ></p>

        <br />
        <p class="tal_l fs_small text_purple fat">
          {{ $t("msg.modalNetwork.title_three") }}
        </p>
        <p
          class="tal_l text_grey fs_small"
          v-html="$t('msg.modalNetwork.text_three')"
        ></p>
        <br />
        <p class="tal_l text_grey fs_small">
          {{ $t("msg.contact_us_any_question") }}
        </p>
        <div class="columns tal_c">
          <div class="column" v-if="!loading">
            <button class="button-slips fat m13_t" @click="closeModalNetwork()">
              {{ $t("msg.continue") }}
            </button>
          </div>

          <div class="column" v-else>
            <button class="button-slips fat m13_t">
              <Loading />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "../public/Loading";
export default {
  props: ["networkId"],
  created() {},
  data: () => ({
    loading: false,
  }),
  methods: {
    closeModalNetwork() {
      this.loading = true;
      this.$emit("closeModalNetwork", this.networkId);
    },
  },
  components: {
    Loading,
  },
};
</script>
<style lang="scss" scope>
#modal_voting {
  background-color: #ffffff;
  margin-top: 5vh;
  width: 100%;
  max-width: 1100px;
  min-height: 710px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  border-radius: 7px;
  word-wrap: break-word;
  font-size: 20px;
  font-size: 1.2em;

  .button-slips {
    background-color: #1e2067;
    padding: 10px 30px;
    font-size: 15px;
    color: white;
    border: none;
    border-radius: 10px;
    margin-top: 20px;
    cursor: pointer;
    &:active {
      background-color: #6146ad;
    }
    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  }

  .coins_cont {
    box-shadow: 0px 2px 4px #041a381a;
    margin-right: 10px;
    border-radius: 21px;
    border: 2px solid transparent;
    margin-bottom: 10px;
    cursor: pointer;
    &:last-child {
      margin-right: 0px;
    }

    &:active {
      background: #8a65f1;
    }
  }

  .selected_coin {
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 20px 40px #041a384d;
    border: 2px solid #c9d1ff;
    border-radius: 21px;
    opacity: 1;
  }

  .coin_info {
    background: #f3f3f3;
    border-radius: 3px;
    min-height: 76.95px;
  }

  .actived_info {
    background-color: #c5c0c0;
  }

  .icon_class_symbol {
    svg {
      width: 40px;
      height: 40px;
    }
  }

  .cont_name {
    min-height: 82px;
  }

  .green {
    color: #00b593;
  }

  .red_color {
    color: #db1f43;
  }

  .header_modal {
    background: #0966aa;
    color: white;
    min-height: 55px;
    border-radius: 7px 7px 0 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .body_modal {
    padding: 20px 60px;
  }

  .content_info {
    border-left: solid 1px #d0d4d9;
    font-size: 13px;
    &:first-child {
      border-left: none;
    }
  }

  .text_info {
    font-weight: 100;
    color: #707070;
  }

  .w30 {
    width: 18%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modals/modalNetworkDist.vue